import { EPageStatusActionTypes } from '../../actions/pageState';
import { EPageState, IPageState } from '../../types/pageState';
import { TReduxActions } from '../../types/redux';
import { ERequestStatus } from '../../types/requestStatus';

export const INITIAL_STATE: IPageState = {
  state: EPageState.RequestForm,
  status: ERequestStatus.Initial,
};

export function pageStateReducer(state: IPageState = INITIAL_STATE, action: TReduxActions) {
  switch (action.type) {
    case EPageStatusActionTypes.OpenRequestForm:
      return {
        ...state,
        state: EPageState.RequestForm,
        status: ERequestStatus.Initial,
      };

    case EPageStatusActionTypes.SetFailure:
      return {
        ...state,
        status: ERequestStatus.Failure,
      };

    case EPageStatusActionTypes.SetSubmitting:
      return {
        ...state,
        status: ERequestStatus.Loading,
      };

    case EPageStatusActionTypes.SetSuccess:
      return {
        ...state,
        state: EPageState.RequestSent,
        status: ERequestStatus.Success,
      };

    default:
      return state;
  }
}
